export default {
  en: {
    inactive: 'This media is no longer available',
    failed: 'This content is no longer available',
    incollections: 'In collections',
  },
};
